import ListBulletIcon from "@heroicons/react/24/solid/ListBulletIcon";
import UsersIcon from "@heroicons/react/24/solid/UsersIcon";
import SettingsIcon from "@heroicons/react/24/solid/Cog6ToothIcon";
import MapPinIcon from "@heroicons/react/24/solid/MapPinIcon";
import UserGroupIcon from "@heroicons/react/24/solid/UserGroupIcon";
import SportsMmaIcon from "@mui/icons-material/SportsMma";
import GroupWorkIcon from "@mui/icons-material/GroupWork";
import { SvgIcon } from "@mui/material";
import { ROUTES } from "../../../constants";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import GrassIcon from "@mui/icons-material/Grass";
import SportsIcon from '@mui/icons-material/Sports';

export const adminItems = [
  {
    title: "Kampprogram",
    paths: [
      ROUTES.ADMIN,
      ROUTES.ADMIN_MATCHES,
      ROUTES.ADMIN_GENERATE_TOURNAMENT,
      ROUTES.ADMIN_CREATE_MATCH,
      ROUTES.ADMIN_TABLE,
    ],
    icon: (
      <SvgIcon fontSize="small">
        <ListBulletIcon />
      </SvgIcon>
    ),
    disabled: false,
    external: false,
  },
  {
    title: "Puljer",
    paths: [ROUTES.ADMIN_PULJER, ROUTES.ADMIN_CREATE_PULJE],
    icon: (
      <SvgIcon fontSize="small">
        <EmojiEventsIcon />
      </SvgIcon>
    ),
    disabled: false,
    external: false,
  },
  {
    title: "Grupper",
    paths: [ROUTES.ADMIN_GROUPS, ROUTES.ADMIN_CREATE_GROUP],
    icon: (
      <SvgIcon fontSize="small">
        <GroupWorkIcon />
      </SvgIcon>
    ),
    disabled: false,
    external: false,
  },
  {
    title: "Hold",
    paths: [ROUTES.ADMIN_TEAMS, ROUTES.ADMIN_CREATE_TEAM],
    icon: (
      <SvgIcon fontSize="small">
        <UserGroupIcon />
      </SvgIcon>
    ),
    disabled: false,
    external: false,
  },
  {
    title: "Seeding",
    paths: [ROUTES.ADMIN_SEEDING],
    icon: (
      <SvgIcon fontSize="small">
        <GrassIcon />
      </SvgIcon>
    ),
    disabled: false,
    external: false,
  },
  {
    title: "Knockout",
    paths: [ROUTES.ADMIN_KNOCK_OUT],
    icon: (
      <SvgIcon fontSize="small">
        <SportsMmaIcon />
      </SvgIcon>
    ),
    disabled: false,
    external: false,
  },
  {
    title: "Baner",
    paths: [ROUTES.ADMIN_LOCATIONS, ROUTES.ADMIN_CREATE_LOCATION],
    icon: (
      <SvgIcon fontSize="small">
        <MapPinIcon />
      </SvgIcon>
    ),
    disabled: false,
    external: false,
  },
  {
    title: "Dommere",
    paths: [ROUTES.ADMIN_REFEREES, ROUTES.ADMIN_CREATE_REFEREE],
    icon: (
      <SvgIcon fontSize="small">
        <SportsIcon />
      </SvgIcon>
    ),
    disabled: false,
    external: false,
  },
  {
    title: "Topscore",
    paths: [ROUTES.ADMIN_TOPSCORE],
    icon: (
      <SvgIcon fontSize="small">
        <UsersIcon />
      </SvgIcon>
    ),
    disabled: false,
    external: false,
  },
  {
    title: "Indstillinger",
    paths: [ROUTES.ADMIN_SETTINGS],
    icon: (
      <SvgIcon fontSize="small">
        <SettingsIcon />
      </SvgIcon>
    ),
    disabled: false,
    external: false,
  },
];

export const superAdminItems = [
  {
    title: "Turneringer",
    paths: [ROUTES.SUPER_ADMIN, ROUTES.SUPER_ADMIN_TOURNAMENTS, ROUTES.SUPER_ADMIN_CREATE_TOURNAMENT],
    icon: (
      <SvgIcon fontSize="small">
        <ListBulletIcon />
      </SvgIcon>
    ),
    disabled: false,
    external: false,
  },
  {
    title: "Brugere",
    paths: [ROUTES.SUPER_ADMIN_USERS, ROUTES.SUPER_ADMIN_CREATE_USERS],
    icon: (
      <SvgIcon fontSize="small">
        <UsersIcon />
      </SvgIcon>
    ),
    disabled: false,
    external: false,
  },
];
